import dateFormat from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { MUTATION_GROUP } from './constants.tsx';
import type { JiraDateFieldInput } from './types.tsx';

export const mutateDateField = (date: string, fieldId: string): JiraDateFieldInput => {
	const dateInputFormat = 'yyyy-MM-dd';
	return {
		fieldId,
		date: { formattedDate: dateFormat(parseISO(date), dateInputFormat) },
		mutationGroup: MUTATION_GROUP,
	};
};

// when date is empty string/null nothing needs to be sent
export const transformDate = (date: string): string | null => date || null;
